import { useEffect, useState, useCallback } from "react";

export function useInfiniteScroll({
  loading,
  hasMore,
  loadMore,
}: {
  loading: boolean;
  hasMore: boolean;
  loadMore: () => void;
}) {
  const [isAtBottom, setIsAtBottom] = useState(false);
  const [node, setNode] = useState<HTMLElement | null>(null);

  const refCallback = useCallback((el: HTMLElement | null) => {
    setNode(el);
  }, []);

  useEffect(() => {
    if (!node) return;
    const observer = new window.IntersectionObserver(
      (entries) => {
        const isIntersecting = entries[0].isIntersecting;
        setIsAtBottom(isIntersecting);
        if (isIntersecting && hasMore && !loading) {
          loadMore();
        }
      },
      { threshold: 0.1 },
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [node, loadMore, loading, hasMore]);

  return { isAtBottom, refCallback };
}
